import React, { useState, useEffect } from 'react';
import './WaterDropAnimation.css';

interface Drop {
  id: number;
  x: number;
  y: number;
  animationDelay: number;
}

interface Ripple {
  id: number;
  x: number;
  y: number;
  delay: number;
}

interface WaterDropAnimationProps {
  onRippleCreate?: (x: number, y: number) => void;
}

export const WaterDropAnimation: React.FC<WaterDropAnimationProps> = ({ onRippleCreate }) => {
  const [drops, setDrops] = useState<Drop[]>([]);
  const [ripples, setRipples] = useState<Ripple[]>([]);
  const [dropId, setDropId] = useState(0);
  const [rippleId, setRippleId] = useState(0);

  // Auto-generate water drops only
  useEffect(() => {
    const interval = setInterval(() => {
      // Create water drop
      const newDrop: Drop = {
        id: dropId,
        x: Math.random() * window.innerWidth,
        y: -80, // Start higher for bigger drops
        animationDelay: 0
      };

      setDrops(prev => [...prev, newDrop]);
      setDropId(prev => prev + 1);

      // Remove drop after animation completes and create ripple
      setTimeout(() => {
        const landingY = Math.random() * (window.innerHeight * 0.7) + (window.innerHeight * 0.3);
        
        const newRipple: Ripple = {
          id: rippleId,
          x: newDrop.x,
          y: landingY,
          delay: 0
        };

        setRipples(prev => [...prev, newRipple]);
        setRippleId(prev => prev + 1);
        onRippleCreate?.(newDrop.x, landingY);

        // Remove ripple after animation
        setTimeout(() => {
          setRipples(prev => prev.filter(ripple => ripple.id !== newRipple.id));
        }, 3000);

        setDrops(prev => prev.filter(drop => drop.id !== newDrop.id));
      }, 2500); // Longer fall time for bigger drops

    }, Math.random() * 2000 + 4000); // Random interval between 4-6 seconds

    return () => clearInterval(interval);
  }, [dropId, rippleId, onRippleCreate]);

  return (
    <div className="water-drop-animation">
      {/* Water Drops */}
      {drops.map(drop => (
        <div
          key={drop.id}
          className="water-drop big-drop"
          style={{
            left: drop.x,
            top: drop.y,
            animationDelay: `${drop.animationDelay}ms`
          }}
        >
          <div className="drop-body"></div>
          <div className="drop-tail"></div>
          <div className="drop-highlight"></div>
        </div>
      ))}

      {/* Water Ripples */}
      {ripples.map(ripple => (
        <div
          key={ripple.id}
          className="water-ripple-container"
          style={{
            left: ripple.x,
            top: ripple.y,
          }}
        >
          <div className="water-ripple-ring ring-1"></div>
          <div className="water-ripple-ring ring-2"></div>
          <div className="water-ripple-ring ring-3"></div>
          <div className="water-ripple-ring ring-4"></div>
          <div className="water-ripple-ring ring-5"></div>
        </div>
      ))}
    </div>
  );
};